import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, Typography, Grid, TextField } from "@material-ui/core";
import { Check, CheckCircle, Refresh } from "@material-ui/icons";

import {
  conductStudentResearch,
  suggestSRResearchCode,
} from "../../../reducer/studentResearch/action";
import SectionCard from "./SectionCard";
import { getEndYear } from "../../../utils/researchCodeYear";

// ConductConfirm — Phòng QLKH duyệt thực hiện đề tài SV. Refactor 2026-05-21:
// thêm ô **Mã đề tài** editable (cùng pattern IR ReviewByAdminForm). Admin có
// thể giữ mã auto-gen từ BE (SVNCKH_<khoa>_{yy}.{seq}) hoặc nhập mã custom.
export default function ConductConfirm({ detail, onDone }) {
  const dispatch = useDispatch();
  const [researchCode, setResearchCode] = useState(detail?.researchCode || "");
  const [saving, setSaving] = useState(false);
  const [suggestLoading, setSuggestLoading] = useState(false);

  // endYear — năm của ngày kết thúc đề tài, quyết định 2 số {yy} của mã
  // (đề tài kết thúc 2027 → SVNCKH_<khoa>_27.xx). 0 → BE fallback theo năm học.
  const endYear = getEndYear(detail?.endTime);

  // Pre-fill code khi mở form: nếu đề tài chưa có code, gọi BE suggest.
  useEffect(() => {
    const fillSuggest = async () => {
      if (detail?.researchCode) return;
      if (!detail?.schoolYear) return;
      setSuggestLoading(true);
      try {
        const s = await suggestSRResearchCode(
          detail.schoolYear,
          detail?.departmentId,
          endYear
        );
        if (s) setResearchCode(s);
      } finally {
        setSuggestLoading(false);
      }
    };
    fillSuggest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail?.id]);

  const handleRefreshSuggest = async () => {
    if (!detail?.schoolYear) return;
    setSuggestLoading(true);
    try {
      const s = await suggestSRResearchCode(
        detail.schoolYear,
        detail?.departmentId,
        endYear
      );
      if (s) setResearchCode(s);
    } finally {
      setSuggestLoading(false);
    }
  };

  const handleConduct = async () => {
    if (!researchCode.trim()) {
      alert("Vui lòng nhập Mã đề tài (hoặc giữ mã gợi ý).");
      return;
    }
    setSaving(true);
    try {
      const ok = await dispatch(conductStudentResearch(detail.id, researchCode.trim()));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<CheckCircle />} title="Duyệt thực hiện đề tài" marginTop={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" gutterBottom>
              Xác nhận <b>duyệt thực hiện</b> đề tài:
            </Typography>
            <Box
              padding={2}
              bgcolor="#fafafa"
              border="solid 1px #e0e0e0"
              borderRadius={4}
              marginTop={1}
            >
              <Typography variant="body1">
                <b>{detail?.name}</b>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>Mã đề tài</b>{" "}
              <span style={{ color: "#c62828" }}>*</span>
              <Typography component="span" variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
                (gợi ý tự sinh, admin sửa tuỳ ý)
              </Typography>
            </Typography>
            <Box display="flex" gridGap={8} alignItems="center">
              <TextField
                fullWidth size="small" variant="outlined"
                value={researchCode}
                disabled={suggestLoading || saving}
                onChange={(e) => setResearchCode(e.target.value)}
                placeholder="VD: SVNCKH_CNTT_26.01"
              />
              <Button
                size="small" variant="outlined"
                startIcon={<Refresh />} disabled={suggestLoading || saving}
                onClick={handleRefreshSuggest}
              >
                Gợi ý
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Sau khi duyệt, hệ thống sẽ <b>gán mã đề tài</b> ở trên và chuyển sang
              giai đoạn thực hiện. Nếu cần yêu cầu chỉnh sửa hoặc loại đề tài, hãy
              dùng chức năng "Yêu cầu chỉnh sửa / Loại" bên cạnh.
            </Typography>
          </Grid>
        </Grid>
      </SectionCard>

      <Box
        marginTop={3}
        paddingTop={2}
        display="flex"
        justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<Check />}
          disabled={saving || suggestLoading}
          onClick={handleConduct}
        >
          Duyệt & cấp mã đề tài
        </Button>
      </Box>
    </Box>
  );
}
